import { ThemeInterface } from '@westwing/ui-kit/Theme';
import styled, { ThemeProps } from 'styled-components';

interface BackdropProps extends ThemeProps<ThemeInterface> {
    disablePointerEvents: boolean;
}
export const Backdrop = styled.div<BackdropProps>`
    background: ${(props: BackdropProps) => props.theme.colors.charcoal100};
    height: 100vh;
    left: 0;
    opacity: 0.5;
    position: fixed;
    top: 0;
    transform: translateZ(0);
    width: 100vw;
    z-index: 1001;
    pointer-events: ${(props: BackdropProps) => (props.disablePointerEvents ? 'none' : 'initial')};
`;
